<template>
  <form role="form">
    <div class="row justify-content-md-center">
      <div class="col-12">
        <label class="form-control-label">Classificação de Acesso</label>
        <multiselect v-model="client.financial_classifications" 
          :options="groups" 
          group-values="classifications"
          group-label="origin" 
          :group-select="false" 
          placeholder="Selecione ou nomeie uma classificação"
          label="description" 
          track-by="id"
          :multiple="true"
          :limit="1"
          :limit-text="limitText" 
          :close-on-select="false"
          :preserveSearch="true"
          :showNoResults="false"
          @search-change="updateNewClassification"
        >
          <template slot="beforeList" class="">
            <div @click="toggleSelectAll" :class="allSelected ? 'all-selected' : 'multiple select-all-option'" :style="allSelected ? 'background-color: #e9ecef; color: #212529' : ''">
              <span :style="allSelected ? 'font-weight: 700' : ''">{{ allSelected ? 'desmarcar todos' : 'selecionar todos' }}</span>
            </div>
          </template>
        </multiselect>
        <div
          class="invalid-feedback"
          v-if="validatedCultureAttributes && 
            !client.financial_classifications
          "
          style="display: block;"
        >
          Campo Obrigatório
        </div>
      </div>
      <div class="mt-4 mb-4">
        <base-button
          class="button-culture colorButtomStandart"
          type="secundary"
          @click="addCulture"
          size="sm"
          ><i class="ni ni-fat-add"></i>Adicionar Cultura</base-button
        >
      </div>
      <div 
        v-for="(cultureIdAttribute, index) in cultureIdsAttributes"
        v-if="!cultureIdAttribute['_destroy']" 
        :key="index" class="col-12"
      >
        <div>
          <div class="mb-4">
            <label class="form-control-label">Propriedade do cliente</label>
            <multiselect v-model="cultureIdAttribute.client_property" 
              :options="filteredClientProperties" 
              :group-select="false"
              placeholder="Selecione uma propriedade" 
              label="descricao" 
              track-by="id" 
              :allow-empty="false"
              :preserveSearch="true" 
              :showNoResults="false" 
              @input="updateClientArea"
              :required="true"
            >
            </multiselect>
            <small v-if="filteredClientProperties.length > 0 && !validateClientProperty(cultureIdAttribute.client_property)" class="text-warning">
              Propriedade do cliente  é obrigatório
            </small>
          </div>
          <label class="form-control-label">Cultura Associada {{ index + 1 }}</label>
          <multiselect style="min-height: 5rem !important;" 
            v-model="cultureIdAttribute.culture" 
            :options="cultures" 
            group-values="cultures" 
            placeholder="Selecione culturas a vincular"
            label="description"
            track-by="id"
            @input="handleCultureInput(cultureIdAttribute)"
          />
        </div>
        <div class="mb-4">
          <base-input 
            placeholder="Ex: 255,5"
            :label="`Área ${ cultureIdAttribute.culture ? cultureIdAttribute.culture.description : '' }`"
            type="number" 
            v-model="cultureIdAttribute.culture_area"
            @input="updateClientArea"
            >
          </base-input>
        </div>
        <div class="mb-2">
          <base-input
            v-model="cultureIdAttribute.cost_hectare"
            label="Índice tecnológico"
            mask="money"
            @input="updateClientArea"
            :loading="is_loading"
            readonly
          />
        </div>
        <div class="mb-2">
          <base-input
            :value="getPotentialCulture(cultureIdAttribute)"
            label="Potencial Cultura"
            readonly
            mask="money"
          />
        </div>
        <div class="col-12 mt-2 mb-4">
          <base-button
            type="secundary"
            @click="removeAssociatedCulture(index)"
            class="colorButtomRemove"
            size="sm"
            ><i class="ni ni-fat-delete"></i
          ></base-button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import swal from "sweetalert2";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

export default {
  name: 'client-form',
  components: {
    Multiselect,
  },
  props: {
    client: {
      type: Object,
      required: true,
    },
    valid: {
      type: Boolean
    }
  },
  data() {
    return {
      groups: [
        {
          origin: 'Nova Classificação',
          classifications: [
            { description: '', id: 'new' },
          ]
        },
        {
          origin: 'Classificações Existentes',
          classifications: []
        },
      ],
      is_loading: false,
      allSelectedActive: false,
      regions: [],
      cultures: [],
      validatedCultureAttributes: {},
      client_properties: [],
      cultureIdsAttributes: []
    }
  },
  methods: {
    async initCicles(cultureIdAttribute) {
      this.is_loading = true;
      try {
        const anosafraId = this.$store.state.currentAnosafra.id;
        const cultureId = cultureIdAttribute.culture.id;

        const response = await this.$http.secured
          .get('/api/v1/cicles', {
            params: {
              anosafra_id: anosafraId,
              culture_id: cultureId
            }
          })
        return response.data
      } catch (error) {
        console.error('Erro ao inicializar os ciclos:', error);
      } finally {
        this.is_loading = false;
      }
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.client.financial_classifications = [];
        this.allSelectedActive = false;
      } else {
        this.client.financial_classifications = [... this.groups[1].classifications];
        this.allSelectedActive = true;
      }
    },
    clearForm() {
      this.client.financial_classifications = [];
      this.cultureIdsAttributes = [];
    },
    initFinancialClassifications() {
      this.$http.secured.get('/api/v1/financial_classifications')
        .then(response => this.groups[1].classifications = response.data)
    },
    initRegions() {
      this.$http.secured.get('/api/v1/regions')
        .then(response => this.regions = response.data)
    },
    updateClientArea() {
      this.client.culture_ids_attributes = this.cultureIdsAttributes.map(attr => {
        return {
          culture_id: attr.culture ? attr.culture.id : null,
          client_property_id: attr.client_property ? attr.client_property.id : null,
          cost_hectare: attr.cost_hectare,
          culture_area: attr.culture_area,
          id: attr.id,
          _destroy: attr._destroy
        }
      })
    },
    limitText(count) { 
      return `+ ${count}`;
    },
    loadCultures() {

    this.$http.secured
      .get('/api/v1/cultures', {
        params: {
          unpaged: true,
        }
      })
      .then(response => 
      this.cultures = this.groupCultures(response.data))
    },
    updateNewClassification(description) {
      if (description) {
        const classificationExists = this.groups[1].classifications.some(classification => {
          const classificationDescription = (classification.description || '').toString().toLowerCase();
          const searchDescription = (description || '').toString().toLowerCase();
          return classificationDescription === searchDescription;
        });

        if (classificationExists) {
          this.$toasted.global.defaultWarnig({
            msg: 'Classificação já existe, por favor escolha outro nome.',
          });
          this.groups[0].classifications[0].description = '';
        } else {
          this.groups[0].classifications[0].description = description;
        }
      }
    },
    moveNewClassification() {
      this.initFinancialClassifications()
      this.$set(this.groups, 0, {...this.groups[0], classifications: [{ description: '', id: 'new' }] })
    },
    groupCultures(xs) {
      return xs.reduce(function (rv, x) {
        let existingGroup = rv.find(e => x.channel_id == e.cultures[0].channel_id)
        if (existingGroup) {
          existingGroup.cultures.push(x)
        } else {
          rv.push({
            channel: x.chanel_id,
            cultures: [x]
          })
        }
        return rv;
      }, []);
    },
    addCulture() {
      this.cultureIdsAttributes.push({
        culture: null,
        client_property: null,
        cost_hectare: null,
        culture_area: null,
        enabled: true,
        _destroy: false
      });
      this.recalculateIndexes();
    },
    getNextAvailableIndex() {
      const indices = this.associatedCultures.map(culture => culture.index);
      
      for (let i = 1; i <= indices.length + 1; i++) {
        if (!indices.includes(i)) {
          return i;
        }
      }
      return indices.length + 1;
    },
    addAssociatedCulture() {
      const newIndex = this.getNextAvailableIndex();
      this.associatedCultures.push({
        index: newIndex,
        culture: {}
      });
    },
    async removeAssociatedCulture(index) {
      const fireResult = await swal.fire({
        title: 'Você tem certeza ?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Tenho Certeza!'
      })

      if(!fireResult.isConfirmed){
        return
      }
      const item = this.cultureIdsAttributes[index];

      if (item.id) {
        this.$set(item, '_destroy', true);
      } else {
        this.cultureIdsAttributes.splice(index, 1);
      }
      this.recalculateIndexes();
    },

    recalculateIndexes() {
      let currentIndex = 1; // Iniciar a contagem no índice 1
      this.cultureIdsAttributes.forEach((item) => {
        if (!item._destroy) {
          item.index = currentIndex;
          currentIndex++;
        }
      });
      this.updateClientArea()
    },
    removeCulture(culture) {
      this.$emit('remove:culture', culture)
    },
    populateClientIdAttribute(){
      if (!this.client.lastCultureIds) return;
      
      this.cultureIdsAttributes = this.client.lastCultureIds.map(cia => ({
          ...cia,
          disabled: !!cia.cost_hectare,
          culture: this.cultures
              .flatMap(group => group.cultures)
              .find(culture => culture.id == cia.culture_id),
          client_property: this.client_properties.find(property => property.id === cia.client_property_id)
      }));
    },
    filterClientProperty(id) {
      return this.client_properties.find(property => property.id === id);
    },
    async initClientProperty() {
      try {
        const response = await this.$http.secured.get('/api/v1/client_property', { 
          params: { q: { client_id: this.client.id } } 
        });
        this.client_properties = response.data;
        this.populateClientIdAttribute();
      } catch (error) {
        console.error('Error fetching client property:', error);
      }
    },
    getPotentialCulture(cultureIdAttribute) {
      const valueCulture = parseFloat(cultureIdAttribute.culture_area);
      const valueArea = parseFloat(cultureIdAttribute.cost_hectare);

      if (isNaN(valueCulture) || isNaN(valueArea)) {
        return 0;
      }

      const resultado = valueCulture * valueArea;
      return resultado;
    },
    clearFields(cultureIdAttribute) {
      cultureIdAttribute.cost_hectare = null;
    },
    handleCultureInput(cultureIdAttribute) {
      this.clearFields(cultureIdAttribute)
      this.updateClientArea()
      this.populateTechnogicalIndex(cultureIdAttribute)
    },
    async populateTechnogicalIndex(cultureIdAttribute) {
      const cicles = await this.initCicles(cultureIdAttribute)
      let totalTechnologicalIndex = 0

      if (cicles) {
        totalTechnologicalIndex = cicles.reduce((sum, cicle) => sum + cicle.technological_index, 0);
      }

      cultureIdAttribute.cost_hectare = totalTechnologicalIndex;
    },
    validateClientProperty(value) {
      return this.client_properties.length > 0 && !!value;
    }
  },
  mounted() {
    if (this.$can('index', 'financial_classifications')) {
      this.initFinancialClassifications()
    }
    if (this.$can('index', 'financial_classifications')) {
      this.loadCultures();
    }
    this.initRegions()
    this.initClientProperty()
  },
  computed: {
    allSelected() {
      const financialClassifications = this.client.financial_classifications || [];
      const classifications = (this.groups[1] && this.groups[1].classifications) || [];
      
      return financialClassifications.length === classifications.length;
    },
    filteredClientProperties() {
      return this.client_properties.filter(property => property.situacao === true);
    },
    hasClientProperties() {
      return this.client_properties.length > 0
    },
    isClientPropertyEmpty() {
      return this.cultureIdsAttributes.some(attr => !attr.client_property);
    },
    isValid() {      
      return !(this.hasClientProperties && this.isClientPropertyEmpty) || !this.client.financial_classification;
    },
  },
  watch: {
    filteredClientProperties(newValue) {
      if (newValue.length === 0) {
        this.cultureIdsAttributes.forEach(attr => {
          attr.client_property = null;
        });
      }
    },
    client: function () {
      this.initClientProperty();
    },
    isValid(value) {
      this.$emit('update:valid', value)
    },
    
  },
  watch: {
    cultures(newCultures) {
    if (newCultures && newCultures.length > 0 && this.client.lastCultureIds) {
      this.populateClientIdAttribute();
    }
  }
  }
}
</script>

<style>
.multiselect__tags {
  font-size: 12px !important;
}

.multiselect .multiselect__tags {
  height: auto;
}

.colorButtomStandart{
  color: #2dce89
}
.colorButtomRemove{
  color:#f5365c
}
.all-selected:hover {
  background-color: #41b883  !important; 
  color: white;
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.all-selected {
  height: 30px;
  padding: 12px 10px 30px 12px;
  cursor: pointer;
}
</style>
